import React from 'react';

export const Logo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}>
    <rect x="25" y="30" width="35" height="3.5" fill="currentColor" />
    <rect x="25" y="48" width="25" height="3.5" fill="currentColor" />
    <rect x="25" y="66" width="45" height="3.5" fill="currentColor" />
    
    <circle cx="75" cy="31.75" r="4.5" fill="currentColor" />
    <circle cx="65" cy="49.75" r="4.5" fill="currentColor" />
    <circle cx="85" cy="67.75" r="4.5" fill="currentColor" />
  </svg>
);

export const AppMark: React.FC<{ size?: number; className?: string }> = ({ size = 26, className = '' }) => (
  <span
    className={`inline-grid shrink-0 place-items-center bg-gradient-to-b from-[#2b8cff] to-[#0062e0] text-white shadow-[inset_0_0_0_0.5px_rgba(255,255,255,0.25),0_1px_2px_rgba(0,40,120,0.25)] ${className}`}
    style={{ width: size, height: size, borderRadius: size * 0.27 }}
    aria-hidden="true"
  >
    <Logo style={{ width: size * 0.82, height: size * 0.82 }} />
  </span>
);
